import '../styles/About.css';

const About = () => {
  return (
    <section className="about-section">
      <h2 className="section-title">About me</h2>

      <div className="about-content">
        <div className="about-text">
          <p>
            I am Man Teng, from Singapore studying in NUS as an Information Systems
            major and I love all things tech! I enjoy creating my own side projects during
            my free time and playing around with open source libraries.
          </p>
          <p>
            Beyond tech, I also love fitness, food and learning new languages. I do both
            long and short distance running, weight training, swimming and cycling.
          </p>
          <a href="/See Man Teng CV.pdf" download className="download-cv-btn">
            Download CV
          </a>
        </div>

        <div className="profile-image-container">
          <img
            src="/images/my pic.JPG"
            alt="Man Teng See"
            className="profile-photo circular"
          />
        </div>
      </div>
    </section>
  );
};

export default About;
